// extracted by mini-css-extract-plugin
export default {"header":"styles_header__+2-y5","link":"styles_link__mHos4"};